<template>
  <b-modal id="login-modal" 
    hide-footer 
    hide-header 
    no-close-on-esc 
    no-close-on-backdrop 
    hide-header-close
    size="xl"
    >
    <Login :modal="true" @success="onSuccess"></Login>
  </b-modal>
</template>

<script>
import Login from '@/views/Login';

export default {
  name: 'LoginModal', 
  components: {
    Login
  },
  props: {
  },
  methods : {
    onSuccess(){
      this.$emit('ok');
      this.$bvModal.hide('login-modal')
    },
    show(){
      this.$bvModal.show('login-modal')
    }
  },
  computed: {
    loginModalState: function() {
      return this.$store.state.loginModal.state;
    }
  },
  watch: {
    loginModalState: function(value) {
      if(value === "visible") {
        this.show();
      }
    }
  }
}
</script>

<style lang="scss">
div.modal-body {
  padding: 0;

  .full-page > .content {
    padding-top: 1vh;
  }

  div.wrapper.wrapper-full-page {
    min-height: 85vh;
    height: 90%;
  }
}

</style>

